import type { Organization } from "schema-dts";

export default function useSchemaOrgPlatformOrganisation() {
  const platformStore = usePlatformStore();

  return {
    "@type": "Organization",
    name: platformStore.getPlatformName,
    url: `https://${platformStore.getPlatformConfiguration.primaryDomain}`,
    logo: {
      "@type": "ImageObject",
      url: platformStore.getPlatformConfiguration.assets.primaryLogo,
      width: "100",
      height: "100",
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "+31-085-401-4764",
        email: "support@matchwornshirt.com",
        contactType: "customer support",
      },
    ],
  } satisfies Organization;
}
